import { render, staticRenderFns } from "./UndoIcon.vue?vue&type=template&id=6adbe55c&scoped=true&"
import script from "./UndoIcon.vue?vue&type=script&lang=js&"
export * from "./UndoIcon.vue?vue&type=script&lang=js&"
import style0 from "./UndoIcon.vue?vue&type=style&index=0&id=6adbe55c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6adbe55c",
  null
  
)

export default component.exports